module.exports = __webpack_public_path__ + "static/media/test.0a769da5.svg";